import { render, staticRenderFns } from "./Insurances.vue?vue&type=template&id=3ac018bc"
import script from "./Insurances.vue?vue&type=script&lang=ts"
export * from "./Insurances.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports